import angular from 'angular';
import { VideoStillImageBackgroundController } from './video-still-image-background';
import template from './video-still-image-background.html';
const VideoStillImageBackground = {
    template,
    bindings: {
        triggerOn: '<',
    },
    controller: VideoStillImageBackgroundController,
};
export default angular
    .module('doxy.videoChat.videoStillBackground', [])
    // video-still-image-background
    .component('videoStillImageBackground', VideoStillImageBackground).name;
